import React from "react";
import moment from "moment";
import { makeStyles, Box, Paper, Typography } from "@material-ui/core";

const useClasses = makeStyles(theme => ({
  meta: {
    fontSize: 12,
    paddingTop: "3px",
    color: theme.palette.grey[500]
  }
}));

const ChatBubble = ({
  name,
  time,
  message,
  align = "left",
  backgroundColor = "transparent"
}) => {
  const classes = useClasses();

  return (
    <Box mb={1}>
      <Paper variant="outlined" style={{ backgroundColor: backgroundColor }}>
        <Box p={2}>
          <Typography>{message}</Typography>
        </Box>
      </Paper>
      <Typography align={align} className={classes.meta}>
        {name} - {moment(time).format("h:mma")}
      </Typography>
    </Box>
  );
};

export { ChatBubble };
